import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container,Row, Col } from 'react-bootstrap';



function MPP_admissions_2023() {
    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left'>
                        <Admissionleft></Admissionleft>
                    </Col>

                    <Col md={8} className='c-left me-8'>
                        <div className="c-heading">
                            <h3>Master of Public Policy (MPP) Admissions 2023</h3> <br/>
                        </div>
                        
                        <div className="border-dark">
                            <h4 className='c-headline mt-5 mb-3'>Master of Public Policy (MPP) - Selected Candidates </h4>
                            <ul className='ms-3 c-lineheight2dot5 iarrow text-orange' >
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='glowing-text text-maroon fw-bold' to="https://files.iittp.ac.in/pdfs/msphd/admissions/2023/MPP-Selected.pdf" target="_blank"> Selected Candidates List</Link> </li>
                            </ul>

                            <h4 className='c-headline mt-5 mb-3'>Master of Public Policy (MPP) - Shortlisted Candidates for Interview  </h4>
                            <ul className='ms-3 c-lineheight2dot5 iarrow text-orange' >
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="https://files.iittp.ac.in/pdfs/msphd/admissions/2023/MPP-interview_shortlisted_candidates.pdf" target="_blank"> Shortlisted Candidates for Interview</Link> </li>
                            </ul>

                            <h4 className='c-headline mt-5 mb-3'>For Track -2 Admissions (For candidates who don't have a valid GATE score) </h4>
                            <ul className='ms-3 c-lineheight2dot5 iarrow text-orange' >
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="https://files.iittp.ac.in/pdfs/msphd/admissions/2023/MPP-%20Shortlist%20-%20Track%202.pdf" target="_blank"> Shortlisted candidates list for the written test under Track-2</Link> </li>
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="#"> Written Examination Date: May 20, 2023</Link> </li>
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="#"> Mode of Written Test: Online</Link> </li>
                            </ul>

                            <h4 className='c-headline mt-5 mb-3'>For both Track-1( candidates shortlisted with a Valid GATE score) and Track-2 (candidates shortlisted in the written test)  </h4>
                            <ul className='ms-3 c-lineheight2dot5 iarrow text-orange' >                                
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="#"> Interview Date: June 7-9, 2023</Link> </li>
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="#">Mode of Interview: Hybrid</Link> </li>
                            </ul>

                            <h4 className='c-headline mt-5 mb-3'>Syllabus </h4>
                            <ul className='ms-3 c-lineheight2dot5 iarrow text-orange' >
                                <li><i className="fal fa-arrow-alt-circle-right me-3 c-link " /> <Link className='text-maroon fw-bold' to="https://files.iittp.ac.in/pdfs/msphd/admissions/2023/Syllabus-MPP.pdf" target="_blank"> Master of Public Policy (MPP)</Link> </li>                                
                            </ul>
                            
                        </div>
                    </Col>
                </Row>
            </Container>

        </section>
    );
}

export default MPP_admissions_2023;
